// 常量配置管理
export interface AppConstants {
  pagination: {
    defaultPageSize: number;
    maxPageSize: number;
    pageSizeOptions: number[];
  };
  limits: {
    maxFileSize: number; // 字节
    maxUploadFiles: number;
    maxSearchResults: number;
  };
  timeouts: {
    default: number;
    short: number;
    long: number;
  };
  errors: {
    rateLimitCode: number;
    unauthorizedCode: number;
    notFoundCode: number;
  };
}

// 默认常量配置
export const defaultConstants: AppConstants = {
  pagination: {
    defaultPageSize: 30,
    maxPageSize: 200,
    pageSizeOptions: [10, 20, 50, 100, 200],
  },
  limits: {
    maxFileSize: 10 * 1024 * 1024, // 10MB
    maxUploadFiles: 5,
    maxSearchResults: 1000,
  },
  timeouts: {
    default: 10000,
    short: 5000,
    long: 30000,
  },
  errors: {
    rateLimitCode: 4291,
    unauthorizedCode: 401,
    notFoundCode: 404,
  },
};

// 生产环境常量配置
export const productionConstants: AppConstants = {
  ...defaultConstants,
  pagination: {
    ...defaultConstants.pagination,
    defaultPageSize: 50,
  },
  limits: {
    ...defaultConstants.limits,
    maxFileSize: 50 * 1024 * 1024, // 50MB
  },
};

// 测试环境常量配置
export const testConstants: AppConstants = {
  ...defaultConstants,
  pagination: {
    ...defaultConstants.pagination,
    defaultPageSize: 30,
  },
  limits: {
    ...defaultConstants.limits,
    maxFileSize: 1 * 1024 * 1024, // 1MB
  },
};

// 获取常量配置
export const getConstants = (): AppConstants => {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
  
  switch (env) {
    case 'production':
      return productionConstants;
    case 'test':
      return testConstants;
    default:
      return defaultConstants;
  }
};

// 导出常量配置实例
export const constants = getConstants(); 